import React from 'react';
import {
    Segment,
    Table,
    Header,
    Form,
    Button,
    Select,
    Input
} from 'semantic-ui-react';

export default class AddressForm extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            addresses: [],

            editAddressMode: false,
            street: '',
            place: '',
            municipality: null,
            canton: null,
            entity: null,
            country: null,

            disabledMunicipality: false,
            disabledCanton: false,
            disabledEntity: false,

            streetError: false,
            placeError: false,
            municipalityError: false,
            cantonError: false,
            entityError: false,
            countryError: false,
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleMunicipalityChange = this.handleMunicipalityChange.bind(this);
        this.handleCantonChange = this.handleCantonChange.bind(this);
        this.handleEntityChange = this.handleEntityChange.bind(this);
        this.handleCountryChange = this.handleCountryChange.bind(this);
        this.onAddNewAddress = this.onAddNewAddress.bind(this);
        this.getAddresses = this.getAddresses.bind(this);
    }

    componentDidMount() {
        this.getAddresses();
    }

    getAddresses() {
        const { addresses } = this.props;

        this.setState({
            addresses
        });
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            addresses: nextProps.addresses,
        });
    }

    onAddNewAddress() {
        const {
            street,
            place,
            municipality,
            canton,
            entity,
            country,
            disabledMunicipality,
            disabledCanton,
            disabledEntity,
        } = this.state;

        if (street === '' || street === null || place === '' || place === null ||
            (municipality === null && !disabledMunicipality) || (canton === null && !disabledCanton) ||
            (entity === null && !disabledEntity) || country === null
        ) {
            this.setState({
                streetError: street === null || street === '',
                placeError: place === null || place === '',
                countryError: !country,
                municipalityError: municipality === null && !disabledMunicipality,
                cantonError: canton === null && !disabledCanton,
                entityError: entity === null && !disabledEntity,
            });

            return;
        }

        const address = {
            street,
            place,
            municipality: municipality ? { id: municipality } : null,
            canton: canton ? { id: canton } : null,
            entity: entity ? { id: entity } : null,
            country: country ? { id: country } : null,
        };

        this.props.onAddNewAddress(address);
        this.resetValues();
    }

    resetValues() {
        this.setState({
            street: '',
            place: '',
            municipality: null,
            canton: null,
            entity: null,
            country: null,

            disabledMunicipality: false,
            disabledCanton: false,
            disabledEntity: false,

            streetError: false,
            placeError: false,
            municipalityError: false,
            cantonError: false,
            entityError: false,
            countryError: false,
        });
    }

    handleInputChange(e, { name, value }) {
        this.setState({ [name]: value });
    }

    handleMunicipalityChange(e, { value }) {
        const municipality = this.props.municipalities.find(el => el.id === value);

        const canton = municipality.canton ? municipality.canton.id : null;
        const entity = municipality.entity ? municipality.entity.id : null;
        const country = municipality.country ? municipality.country.id : null;

        this.setState({
            municipality: value,
            canton,
            entity,
            country,

        });
    }

    handleEntityChange(e, { value }) {
        let {
            canton, municipality, disabledMunicipality, disabledCanton,
        } = this.state;

        canton = null;
        municipality = null;
        const country = this.props.countries.find(el => el.name === 'Bosna i Hercegovina');

        if (value === 3) {
            disabledCanton = true;
            disabledMunicipality = true;
        } else if (value === 2) {
            disabledCanton = true;
            disabledMunicipality = false;
        } else {
            disabledCanton = false;
            disabledMunicipality = false;
        }

        this.setState({
            entity: value,
            canton,
            municipality,
            country: country.id,
            disabledCanton,
            disabledMunicipality,
        });
    }

    handleCantonChange(e, { value }) {
        const entity = this.props.entities.find(el => el.name === 'Federacija Bosne i Hercegovine');
        const country = this.props.countries.find(el => el.name === 'Bosna i Hercegovina');
        this.setState({
            canton: value,
            municipality: null,
            entity: entity.id,
            country: country.id,
        });
    }

    handleCountryChange(e, { value }) {
        let {
            disabledEntity, disabledCanton, disabledMunicipality
        } = this.state;

        if (value === 22) {
            disabledEntity = false;
            disabledCanton = false;
            disabledMunicipality = false;
        } else {
            disabledEntity = true;
            disabledCanton = true;
            disabledMunicipality = true;
        }

        this.setState({
            country: value,
            disabledEntity,
            disabledCanton,
            disabledMunicipality,
            municipality: null,
            entity: null,
            canton: null,
        });
    }

    displayPlaceProperly(place) {
        let nameBuilder = [];
        if (place.name) nameBuilder.push(place.name);
        if (place.municipality) nameBuilder.push(place.municipality.name);
        if (place.canton) nameBuilder.push(place.canton.name);
        if (place.entity) nameBuilder.push(place.entity.name);
        if (place.country) nameBuilder.push(place.country.name);

        let name = '';
        let nameBuilderSize = nameBuilder.length;
        for (let i = 0; i < nameBuilderSize; i += 1) {
            name += nameBuilder[i];

            if (i !== nameBuilderSize - 1) name += ', ';
        }

        return name;
    }

    render() {
        const { addresses } = this.state;

        return (
            <React.Fragment>
                { !!addresses.length &&
                <Segment>
                    <Table compact size="small" celled>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell>Ulica</Table.HeaderCell>
                                <Table.HeaderCell>Mjesto</Table.HeaderCell>
                                {/* <Table.HeaderCell></Table.HeaderCell> */}
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {addresses.map(el =>
                                (<Table.Row key={el.id}>
                                    <Table.Cell>
                                        {el.street}
                                    </Table.Cell>
                                    <Table.Cell>
                                        {this.displayPlaceProperly(el.place)}
                                    </Table.Cell>
                                    {/* <Table.Cell verticalAlign="middle" className="text-center"> */}
                                    {/*    <Button */}
                                    {/*        basic */}
                                    {/*        color="red" */}
                                    {/*        size="mini" */}
                                    {/*        onClick={() => this.props.onDeleteAddress(el.id)} */}
                                    {/*    > */}
                                    {/*        Arhiviraj */}
                                    {/*    </Button> */}
                                    {/* </Table.Cell> */}
                                </Table.Row>))
                            }
                        </Table.Body>
                    </Table>
                </Segment>}
                { this.props.editMode &&
                    <Segment clearing>
                        <Header as="h5">Dodaj novu adresu</Header>
                        <Form noValidate>
                            <Form.Group widths="3">
                                <Form.Field
                                    control={Input}
                                    onChange={this.handleInputChange}
                                    placeholder="Ulica"
                                    value={this.state.street}
                                    name="street"
                                    required
                                    error={this.state.streetError}
                                />
                                <Form.Field
                                    control={Input}
                                    onChange={this.handleInputChange}
                                    placeholder="Mjesto"
                                    value={this.state.place}
                                    name="place"
                                    required
                                    error={this.state.placeError}
                                />
                                <Form.Field
                                    control={Select}
                                    clearable
                                    onChange={this.handleMunicipalityChange}
                                    placeholder="Opština"
                                    value={this.state.municipality}
                                    options={this.props.municipalities}
                                    name="municipality"
                                    search
                                    disabled={this.state.disabledMunicipality}
                                    required={!this.state.disabledMunicipality}
                                    error={this.state.municipalityError}
                                />
                            </Form.Group>
                            <Form.Group widths="3">
                                <Form.Field
                                    control={Select}
                                    clearable
                                    onChange={this.handleCantonChange}
                                    placeholder="Kanton"
                                    value={this.state.canton}
                                    options={this.props.cantons}
                                    name="canton"
                                    search
                                    disabled={this.state.disabledCanton}
                                    required={!this.state.disabledCanton}
                                    error={this.state.cantonError}
                                />
                                <Form.Field
                                    control={Select}
                                    clearable
                                    onChange={this.handleEntityChange}
                                    placeholder="Entitet"
                                    value={this.state.entity}
                                    options={this.props.entities}
                                    name="entity"
                                    search
                                    disabled={this.state.disabledEntity}
                                    required={!this.state.disabledEntity}
                                    error={this.state.entityError}
                                />
                                <Form.Field
                                    control={Select}
                                    clearable
                                    onChange={this.handleCountryChange}
                                    placeholder="Država"
                                    value={this.state.country}
                                    options={this.props.countries}
                                    name="country"
                                    search
                                    required
                                    error={this.state.countryError}
                                />
                            </Form.Group>
                            <Button primary floated="right" onClick={this.onAddNewAddress}>Dodaj</Button>
                        </Form>
                    </Segment>
                }
            </React.Fragment>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Assets/Leaseholder/LeaseholderAddressEditable.js